export enum EnumLayerSources {
    Internal = 1,
    External = 2,
}